<template>
  <div v-if="richText">
    <RichTextVueParser v-bind="props" :richText />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { RichText } from '@backmarket/http-api/src/api-specs-content/models/rich-text'
import type { RichTextApiProps } from '@backmarket/http-api/src/api-specs-content/models/rich-text-content'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import type { BlockProps } from '../../models/content-block'

import { parseRichText } from './DynamicTextDates.utils'
import RichTextVueParser from './RichTextVueParser.vue'

export type RichTextBlockProps = (RichTextApiProps & {
  h2Style?: string
  lightText?: boolean
  ignoreLinks?: boolean
  styleVariant?: 'default' | 'light' | 'none'
}) &
  BlockProps

const props = withDefaults(defineProps<RichTextBlockProps>(), {
  lightText: false,
  ignoreLinks: false,
  styleVariant: 'default',
  h2Style: undefined,
})

const locale = useI18nLocale()

const richText = computed(() => {
  if (isEmpty(props.richText)) return null

  return parseRichText(props.richText as RichText, locale)
})

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error'])
</script>
